import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import { setRegistrationToken, setUserName } from '@/store/slices/auth/authSlice';
import {
  setRegistrationToken as persistRegistrationToken,
  setRegistrationUsername as persistRegistrationUsername,
} from '@/utils/sessionStorage';
import type { BeginRegistrationDTO } from '@/types/DTOs';

export const verifyOtpThunk = createAppAsyncThunk<
  BeginRegistrationDTO,
  { username: string; otp: string }
>('auth/verifyOtp', async(params, { dispatch, extra: { authService }, rejectWithValue }) => {
  try {
    const normalizedUsername = params.username.toLowerCase();
    dispatch(setUserName(normalizedUsername));
    const result = await authService.beginRegistration({username: normalizedUsername, otp: params.otp });
    dispatch(setRegistrationToken(result.registrationToken));
    persistRegistrationToken(result.registrationToken);
    persistRegistrationUsername(normalizedUsername);
    return result;
  } catch (error) {
    if (isAPIError(error) && error.fieldErrors != null) {
      // Correct: rejectWithValue with expected shape
      return rejectWithValue({ fieldErrors: error.fieldErrors });
    }
    throw error;
  }
});
